<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增部门"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="部门名称" prop="department_name">
                <el-input type="text" v-model="ruleForm.department_name" placeholder="请输入部门名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属公司" prop="company_id">
                <el-select :disabled="companyDisabled" v-model="ruleForm.company_id" placeholder="请选择所属公司"
                           style="width: 100%;">
                    <el-option
                            v-for="item in allCompany"
                            :key="item.id"
                            :value="item.id"
                            :label="item.company_name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序号 (排序值越小越前)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
            if (this.$route.params.company_id) {
                this.ruleForm.company_id = this.$route.params.company_id;
                this.companyDisabled = true;
            }
            if (this.$route.query.company_id) {
                this.ruleForm.company_id = this.$route.query.company_id;
                this.companyDisabled = true;
            }
        },
        mounted() {
            this.createParams();
        },
        data() {
            return {
                companyDisabled: false,
                allCompany: [],
                ruleForm: {
                    department_name: "",
                    company_id: "",
                    sort: "",
                    status: 1,
                },
                rules: {
                    department_name: [
                        {required: true, message: "请输入部门全称", trigger: "blur"},
                    ],
                    company_id: [
                        {required: true, message: "请选择所属公司", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],

                },
                form_width: "40%",
            };
        },
        methods: {
            // 所有地区
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'createCompanyDeparmentParams',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data.all_company;
                });
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
                // window.close()
            },

            // 提交表单
            submitForm(formName) {
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'createCompanyDepartment',
                            'params': {
                                company_id: this.ruleForm.company_id,
                                department_name: this.ruleForm.department_name,
                                sort: this.ruleForm.sort,
                                status: this.ruleForm.status,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    // window.history.go(-1);
                                    _that.$router.push({
                                        name: "deparmentList",
                                        params: {}
                                    });
                                }
                            });
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        return false;
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
